var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-title',{staticClass:"text-uppercase white--text"},[_c('img',{attrs:{"src":require("../../assets/images/qumulex_logo_white.svg"),"height":"20"}})])}
var staticRenderFns = []

export { render, staticRenderFns }